import AppNavbar from "../../Navbar/AppNavbar";
import Footer from "../../Navbar/Footer";
import { Tabs, Tab } from "react-bootstrap";
import { useState } from "react";
import '../../../assets/css/dataCount.scss'
import CountryDataCount from "./CountryDataCount";
import IndustryDataCount from "./IndustryDataCount";

const DataCount = () => {
    const [activeTab, setActiveTab] = useState('country');

    return (
        <div className='page-layout'>
            <AppNavbar />
            <div className='page-content'>
                <div className="upload-report-container">
                    <div className="upload-report-container-header">
                        <h6 className="d-flex align-items-center justify-content-start p-3 m-0">Data</h6>
                        <Tabs
                            id="data-tabs"
                            activeKey={activeTab}
                            onSelect={(k) => setActiveTab(k)}
                            className="mb-3 data-count-tabs"
                        >
                            <Tab eventKey="country" title="Country">
                                {/* Country tab content here */}
                                <CountryDataCount />
                            </Tab>
                            <Tab eventKey="industry" title="Industry">
                                {/* Industry tab content here */}
                                <IndustryDataCount isActive={activeTab === 'industry'} />
                            </Tab>
                        </Tabs>

                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default DataCount;
